import { useNavigate } from 'react-router-dom';

import { useUserBalanceStore } from '@/entities/balance';
import { useCognitoCheckUser, useCurrentUser } from '@/entities/user/currentUser';

import { PATHS } from '@/shared/constants/routes/paths';
import { IS_WHITE_LABEL } from '@/shared/environments';
import { useInterfaceLanguage } from '@/shared/i18n';
import { logout } from '@/shared/lib/logout';
import { showErrorAlert } from '@/shared/lib/showErrorAlert';
import { Profile } from '@/shared/ui/Profile';

export type ProfileItemProps = {
  active?: boolean;
  variant?: 'filled' | 'outlined';
};

export const ProfileItem = ({ active = false, variant = 'filled' }: ProfileItemProps) => {
  const navigate = useNavigate();

  const { data } = useCognitoCheckUser();
  const picture = data?.picture;

  const { data: user } = useCurrentUser();

  const { t } = useInterfaceLanguage();
  const { hasFreeSubscription, hasTrialPlan, isBalanceLoaded, planName: subscriptionPlanName } = useUserBalanceStore();

  const isFreePlan = isBalanceLoaded && (hasTrialPlan || hasFreeSubscription);
  const accountPlanName = isFreePlan ? t('sidebarNav.plan.free') : subscriptionPlanName;
  const planName = IS_WHITE_LABEL ? 'Account' : accountPlanName;

  const handleClick = () => {
    if (!IS_WHITE_LABEL) {
      navigate(`/${PATHS.account}`);
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      showErrorAlert(error);
    }
  };

  return (
    <Profile
      active={active}
      cursor={IS_WHITE_LABEL ? 'default' : 'pointer'}
      data-testid="profile-item"
      email={user?.email}
      picture={picture}
      planName={planName}
      variant={variant}
      handleLogout={IS_WHITE_LABEL ? handleLogout : undefined}
      onClick={handleClick}
    />
  );
};
